/**
 Author - Suyash Chandra
 Git - https://bitbucket.org/SuyashChandra/
 **/

import React, {useState, useEffect} from "react";
import Slider from "react-slick";

let sliderSettings = {
  swipeToSlide: true,
  centerMode: true,
  centerPadding: "60px",
  dots: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  infinite: true,
  arrows: false,
  lazyLoad: true,
  adaptiveHeight: true
};
const TeamMemberCarousel = ({
  content,
  settings
}) => {
  sliderSettings = {...sliderSettings, ...settings};
  const [sliderAutoPlay, setSliderAutoPlay] = useState(true);

  useEffect(() => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      setSliderAutoPlay(false);
    }
  }, []);

  return (
      <>
        <Slider
          autoplay={sliderAutoPlay}
          {...sliderSettings}
        >
          {content}
        </Slider>
      </>
  );
};

export default TeamMemberCarousel;

